import * as React from "react";
import styled from "styled-components";
import { inputPlaceholderStyle, inputStyle, focusStyle } from "../Input";

const Main = styled.div<{ isOpen: boolean; isDropDown: boolean }>`
  ${inputStyle}

  display: flex;
  align-items: center;
  cursor: pointer;

  ${p => p.isOpen && focusStyle}

  & > input {
    font-family: inherit;
    width: 0;
    flex: 1 1 auto;
    outline: 0;
    background-color: transparent;
    border: 0;
    box-shadow: 0;
    cursor: pointer;
    user-select: none;
    ${inputPlaceholderStyle}
  }

  &:hover {
    ${p => !p.isOpen && `background-color:  hsl(0, 0%, 95%);`}
  }

  /* & > svg {
  transition: 0.2s;
} */
`;

type Props = {
  style?: React.CSSProperties;
  className?: string;
  value: string;
  isOpen: boolean;
  onClick: () => void;
  placeholder?: string;
  children?: any;
  isDropDown: boolean;
  [key: string]: any;
};

function Field(
  {
    style,
    className,
    isOpen,
    value,
    onClick,
    placeholder,
    children,
    isDropDown,
    ...rest
  }: Props,
  ref: any
) {
  return (
    <Main
      {...rest}
      ref={ref}
      style={style}
      className={className}
      isOpen={isOpen}
      onClick={onClick}
      isDropDown={isDropDown}
    >
      <input readOnly placeholder={placeholder} value={value} />
      {children}
    </Main>
  );
}

export default React.forwardRef(Field);
